import { render, staticRenderFns } from "./FormRole.vue?vue&type=template&id=9349265a&scoped=true&"
import script from "./FormRole.vue?vue&type=script&lang=js&"
export * from "./FormRole.vue?vue&type=script&lang=js&"
import style0 from "./FormRole.vue?vue&type=style&index=0&id=9349265a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9349265a",
  null
  
)

export default component.exports